import { CSSObject } from '@emotion/react';

export const ButtonIncrease: CSSObject = {
  fontSize: ['xs', 'sm'],
  _hover: {
    bgGradient: 'linear(to-b, alpha.400, alpha.500)',
  },
};
